import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import "./styles/app.sass";
import Page from "./components/Page";
import { PermissionsProvider } from "./context/Permissions/PermissionsContext";
import { BarcodeProvider } from "./context/Barcode/BarcodeContext";
import Home from "./screens/Home";
import ProductsDashboard from "./screens/ProductsDashboard";
import Analytics from "./screens/Analytics"
import Totes from "./screens/Totes";
import TotesDetailPage from "./screens/Totes/TotesDetailPage/index";
import NewProduct from "./screens/NewProduct";
import Drafts from "./screens/Drafts";
import Released from "./screens/Released";
import Comments from "./screens/Comments";
import Scheduled from "./screens/Scheduled";
import Customers from "./screens/Customers";
import CustomerList from "./screens/CustomerList";
import Promote from "./screens/Promote";
import Notification from "./screens/Notification";
import Settings from "./screens/Settings";
import UpgradeToPro from "./screens/UpgradeToPro";
import MessageCenter from "./screens/MessageCenter";
import ExploreCreators from "./screens/ExploreCreators";
import AffiliateCenter from "./screens/AffiliateCenter";
import SignUp from "./screens/SignUp";
import SignIn from "./screens/SignIn";
import Earning from "./screens/Earning";
import Refunds from "./screens/Refunds";
import Payouts from "./screens/Payouts";
import Statements from "./screens/Statements";
import Shop from "./screens/Shop";
import PageList from "./screens/PageList";
import LandingPageIndex from "./LandingPage/LandingPageIndex";
import AllOrders from "./screens/Orders/AllOrders/AllOrders";
import ProtectedRoute from "./features/auth/ProtectedRoute";
import PublicRoute from "./features/auth/PublicRoute";
import AccessControlRoute from "./HOC/AccessRoute";
import MultiAccessRoute from "./HOC/MultiAccessRoute";
import Staffsindex from "./screens/Staff/Staffsindex";
// import ScanOredrs from "./screens/ScanOrders/ScanOrderIndex";
import AddStaffMember from "./screens/Staff/AddStaffMember/AddStaffMember";
import { MenuProvider } from "./context/Roles/MenuContext";
import { ProductProvider } from "./context/Product/ProductContext";
import GeneratePickListByOrderPrintView from "./screens/Orders/AllOrders/Filters/GeneratePickListByOrderPrintView";
import GeneratePickListByProductPrintView from "./screens/Orders/AllOrders/Filters/GeneratePickListByProductPrintView";
import { FormikProvider } from "./screens/Settings/context/SettingsContext";
import OrderDettailsIndex from "./screens/Orders/OrderDetails/OrderDettailsIndex";
import ScanningOrders from "./screens/ScanningOrders/Index";
import UpdateInventory from "./screens/Inventory/UpdateInventory/UpdateInventory";
import InventoryLogs from "./screens/Inventory/InventoryLogs/InventoryLogs";
import Details from "./screens/Inventory/InventoryLogs/InventoryLogsDetails/Details";
import Unauthorized from "./screens/Unauthorized/Unauthorized";
import Sync from "./screens/Sync";
import Privacy from "./screens/Privacy";
import Welcome from "./screens/Welcome";
import PackingSlip from "./components/Packingslip/PackingSlip";
import CreateOrder from "./screens/ManualOrders/CreateOrder";
import RTOrderIndex from "./screens/RTO/Index";
import BarcodePrint from "./screens/BarcodePrint";
import DynamicBarcodePrint from "./screens/DynamicBarcode"
import SettingsDashboard from "./screens/NewSettings/SettingsDashboard";
import SettingsAccessControl from "./screens/NewSettings/Modules/AccessControl/Index";
import SettingsCameras from "./screens/NewSettings/Modules/Cameras/View/View";
import UpdateStoreImage from "./screens/NewSettings/Modules/StoreSettings/UpdateStoreImage/index"
import StoreSettings from "./screens/NewSettings/Modules/StoreSettings/Index";
import StoreSyncOrders from "./screens/NewSettings/Modules/StoreSettings/SyncOrders/Index";
import TagSettings from "./screens/NewSettings/Modules/Tags/TagsSettings/View/Tags";
import TagView from "./screens/NewSettings/Modules/Tags/TagsCategory/View/Index"
import AddCameras from "./screens/NewSettings/Modules/Cameras/CreateCamera/Create"
import UpdateCameras from "./screens/NewSettings/Modules/Cameras/UpdateCamera/Update"
import SettingsRoles from "./screens/NewSettings/Modules/AccessControl/Roles/RolesIndex"
import MobileApplicationIndex from "./screens/NewSettings/Modules/AccessControl/MobileApplication/MobileApplicationIndex";
import SettingsActionBarcodes from "./screens/NewSettings/Modules/ActionBarcodes/Index";
import SettingsActionBarcodesForTag from "./screens/NewSettings/Modules/ActionBarcodes/ActionBarcodeForTags/View/View"
import ActionBarcodeCreate from "./screens/NewSettings/Modules/ActionBarcodes/ActionBarcodeForTags/CreateBarcode/Create";
import ActionBarcodeUpdate from "./screens/NewSettings/Modules/ActionBarcodes/ActionBarcodeForTags/UpdateBarcode/Update";
import SettingsActionBarcodesForCamera from "./screens/NewSettings/Modules/ActionBarcodes/ActionBarcodeForCameras/View/View";
import CreateCameraActionBarcodes from "./screens/NewSettings/Modules/ActionBarcodes/ActionBarcodeForCameras/CreateBarcode/Create";
import UpdateCameraActionBarcodes from "./screens/NewSettings/Modules/ActionBarcodes/ActionBarcodeForCameras/UpdateBarcode/Update";
import CreateRoles from "./screens/NewSettings/Modules/AccessControl/Roles/CreateRole/Create";
import CreatePermission from "./screens/NewSettings/Modules/AccessControl/Roles/CreatePermissions/Create";
import UpdateRole from "./screens/NewSettings/Modules/AccessControl/Roles/UpdateRole/Update";
import InventoryLogsPDF from "./screens/Inventory/InventoryLogs/InventoryLogsPDF/InventoryLogsPDF";
import PrintBarcode from "./screens/PrintBarcode";

function App() {
  return (
    <Routes>
      <Route index path="/*" element={<LandingPageIndex />} />
      <Route index path="/privacy" element={<Privacy />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="/sync" element={<Sync />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<PermissionsProvider />}>
          <Route
            element={
              <AccessControlRoute
                moduleCode="diMGeD"
                requiredPrivilege="91VsM3"
              />
            }
          >
            <Route
              path="/orders"
              element={
                <Page>
                  <AllOrders />
                </Page>
              }
            />

            <Route
              path="/order-details/:id"
              element={
                <Page>
                  <OrderDettailsIndex />
                </Page>
              }
            />
          </Route>
          <Route
            path="/generatePickList"
            element={<GeneratePickListByOrderPrintView />}
          ></Route>
          <Route
            path="/generatePickListByProduct"
            element={<GeneratePickListByProductPrintView />}
          ></Route>
          <Route path="/packingslip" element={<PackingSlip />}></Route>
          <Route path="/barcodeprint" element={<BarcodePrint />} />
          <Route path="/dynamic-barcode-print" element={  <BarcodeProvider><DynamicBarcodePrint /></BarcodeProvider>} />
          <Route
            element={
              <AccessControlRoute
                moduleCode="eV79MY"
                requiredPrivilege="xPGbZk"
              />
            }
          >
            <Route
              path="/staff"
              element={
                <Page title="Staff list">
                  <Staffsindex />
                </Page>
              }
            />
          </Route>

          <Route
            element={
              <AccessControlRoute
                moduleCode="eV79MY"
                requiredPrivilege="9WgfDT"
              />
            }
          >
            <Route
              path="/staff/add"
              element={
                <Page>
                  <AddStaffMember />
                </Page>
              }
            />
          </Route>

          <Route
            element={
              <AccessControlRoute
                moduleCode="eV79MY"
                requiredPrivilege="xPGbZk"
              />
            }
          >
            <Route
              path="/staff/edit/:id"
              element={
                <Page title="Add Member">
                  <AddStaffMember />
                </Page>
              }
            />
          </Route>
          <Route
            element={
              <AccessControlRoute
                moduleCode="Lzk3eg"
                requiredPrivilege="kXdmje"
              />
            }
          >
            <Route
              path="/updateinventory"
              element={
                <Page title="Update Inventory">
                  <UpdateInventory />
                </Page>
              }
            />
          </Route>
          <Route
            element={
              <AccessControlRoute
                moduleCode="Lzk3eg"
                requiredPrivilege="kXdmje"
              />
            }
          >
            <Route
              path="/inventorylogs"
              element={
                <Page title="Inventory Logs">
                  <InventoryLogs />
                </Page>
              }
            />
          </Route>
          <Route
            element={
              <AccessControlRoute
                moduleCode="Lzk3eg"
                requiredPrivilege="kXdmje"
              />
            }
          >
            <Route
              path="/inventorylog/:id"
              element={
                <Page title="Inventory Logs">
                  <Details />
                </Page>
              }
            />
          </Route>
          <Route
              path="/printinventorylog/:id"
              element={
                  <InventoryLogsPDF />
              }
            />
          <Route
            element={
              <MultiAccessRoute
                moduleCodes={["gsZHRE", "FvrVqN", "BjQPiy","k5WoWh","18q9ha","VBaqtS","2sxE9L"]}
                requiredPrivileges={["nnlrNJ", "nJLdKh", "OZnKi4","kI6pTK","4Yy3A1","HRkhhh","OFUpm7"]}
              />
            }
          >
            <Route
              path="/settings"
              element={
                <Page title="Settings">
                  <MenuProvider>
                    {" "}
                    <FormikProvider>
                      <Settings />
                    </FormikProvider>
                  </MenuProvider>
                </Page>
              }
            />
          <Route
          path="/settingsDashboard"
          element={
            <Page showBreadcrumbs={true}>
              <SettingsDashboard />            
            </Page>
          }
          />
          <Route
          path="/settingsDashboard/accessControl"
          element={        
            <Page showBreadcrumbs={true}>
              <SettingsAccessControl/>         
            </Page>
          }
          />
          <Route
          path="/settingsDashboard/storeSettings"
          element={        
            <Page showBreadcrumbs={true}>
              <StoreSettings/>         
            </Page>
          }
          />
          <Route
          path="/settingsDashboard/storeSettings/syncOrders"
          element={        
            <Page showBreadcrumbs={true}>
              <StoreSyncOrders/>         
            </Page>
          }
          />
          <Route
          path="/settingsDashboard/storeSettings/updateStoreImage"
          element={        
            <Page showBreadcrumbs={true}>
              <UpdateStoreImage/>         
            </Page>
          }
          />
          <Route
          path="/settingsDashboard/tags"
          element={        
            <Page showBreadcrumbs={true}>
              <TagSettings/>         
            </Page>
          }
          />
          <Route
          path="/settingsDashboard/tags/:id"
          element={        
            <Page showBreadcrumbs={true}>
              <TagView/>         
            </Page>
          }
          />
         <Route
          path="/settingsDashboard/Cameras"
          element={        
            <Page showBreadcrumbs={true}>
              <SettingsCameras/>         
            </Page>
          }
          />
          <Route
          path="/settingsDashboard/Cameras/create"
          element={        
            <Page showBreadcrumbs={true}>
              <AddCameras/>         
            </Page>
          }
          />
          <Route
          path="/settingsDashboard/Cameras/:id"
          element={        
            <Page showBreadcrumbs={true}>
              <UpdateCameras/>         
            </Page>
          }
          />
          <Route
          path="/settingsDashboard/accessControl/roles"
          element={        
            <Page showBreadcrumbs={true}>
              <SettingsRoles/>     
            </Page>
            }
          />
          <Route
          path="/settingsDashboard/accessControl/roles/create"
          element={        
            <Page showBreadcrumbs={true}>
              <CreateRoles/>     
            </Page>
            }
          />
          <Route
          path="/settingsDashboard/accessControl/roles/:roleId"
          element={        
            <Page showBreadcrumbs={true}>
              <CreatePermission />     
            </Page>
            }
          />
          <Route
          path="/settingsDashboard/accessControl/roles/update/:id"
          element={        
            <Page showBreadcrumbs={true}>
              <UpdateRole />     
            </Page>
            }
          />
          <Route
          path="/settingsDashboard/accessControl/mobileApplication"
          element={        
            <Page showBreadcrumbs={true}>
                <MobileApplicationIndex/>         
            </Page>
          }
          />
          </Route>
          <Route
          path="/settingsDashboard/camera&Barcode"
          element={        
            <Page showBreadcrumbs={true}>
                <SettingsActionBarcodes/>         
            </Page>
                  }
          />
          <Route
          path="/settingsDashboard/camera&Barcode/actionBarcodesForTag"
          element={        
            <Page showBreadcrumbs={true}>
                <SettingsActionBarcodesForTag/>         
            </Page>
             }
          />
          <Route
          path="/settingsDashboard/camera&Barcode/actionBarcodesForTag/create"
          element={        
            <Page showBreadcrumbs={true}>
                <ActionBarcodeCreate/>         
            </Page>
             }
          />
          <Route
          path="/settingsDashboard/camera&Barcode/actionBarcodesForTag/:id"
          element={        
            <Page showBreadcrumbs={true}>
                <ActionBarcodeUpdate/>         
            </Page>
             }
          />
          <Route
          path="/settingsDashboard/camera&Barcode/actionBarcodesForCamera"
          element={        
            <Page showBreadcrumbs={true}>
                <SettingsActionBarcodesForCamera/>         
            </Page>
             }
          />
          <Route
          path="/settingsDashboard/camera&Barcode/actionBarcodesForCamera/create"
          element={        
            <Page showBreadcrumbs={true}>
                <CreateCameraActionBarcodes/>         
            </Page>
             }
          />
          <Route
          path="/settingsDashboard/camera&Barcode/actionBarcodesForCamera/:id"
          element={        
            <Page showBreadcrumbs={true}>
                <UpdateCameraActionBarcodes/>         
            </Page>
             }
          />

          
          
          <Route
            element={
              <AccessControlRoute
                moduleCode="bHp1GE"
                requiredPrivilege="OggEqV"
              />
            }
          >
            <Route
              path="/order/add"
              element={
                <Page>
                  <CreateOrder />
                </Page>
              }
            />
          </Route>

         
          <Route
            path="products/add"
            element={
              <Page title="New product">
                <ProductProvider>
                  <NewProduct />
                </ProductProvider>
              </Page>
            }
          />
           <Route
            path="print-barcode/add"
            element={
              <Page title="Print Barcode">
                
                <BarcodeProvider>
                  <PrintBarcode />
                </BarcodeProvider> 
              </Page>
            }
          />
         
          
         
          <Route
            path="notification"
            element={
              <Page title="Notification">
                <Notification />
              </Page>
            }
          />
          <Route
            path="/analytics"
            element={
              <Page title="Analytics dashboard">
                <Analytics />
              </Page>
            }
          />
          <Route
            path="/totes"
            element={
              <Page>
                <Totes />
              </Page>
            }
          />
          <Route
            path="/totes-details/:toteId"
            element={
              <Page>
                <TotesDetailPage />
              </Page>
            }
          />
          {/* <Route
          path="/scanorder"
          element={
            <Page title="Scan Order">
              <ScanOredrs />
            </Page>
          }
        /> */}
          <Route
            element={
              <AccessControlRoute
                moduleCode="8FZN9w"
                requiredPrivilege="a2YwMA"
              />
            }
          >
            <Route
              path="/scan-order"
              element={
                <Page title="Pack Orders">
                  <ScanningOrders />
                </Page>
              }
            />
          </Route>
          <Route 
           element={
            <AccessControlRoute
              moduleCode="ee014d"
              requiredPrivilege="badc77"
            />
          }>
            <Route
              path="/return-to-origin"
              element={
                <Page title="Return to Origin">
                  <RTOrderIndex />
                </Page>
              }
            />
          </Route>
        
          {/* <Route
          path="products/dashboard"
          element={
            <Page title="Products dashboard">
              <ProductsDashboard />
            </Page>
          }
        />
       
        <Route
          path="products/drafts"
          element={
            <Page title="Drafts">
              <Drafts />
            </Page>
          }
        />
        <Route
          path="products/released"
          element={
            <Page title="Released">
              <Released />
            </Page>
          }
        />
        <Route
          path="products/comments"
          element={
            <Page title="Comments">
              <Comments />
            </Page>
          }
        />
        <Route
          path="products/scheduled"
          element={
            <Page title="Scheduled">
              <Scheduled />
            </Page>
          }
        />
        <Route
          path="customers/overview"
          element={
            <Page title="Customers">
              <Customers />
            </Page>
          }
        />
        <Route
          path="customers/customer-list"
          element={
            <Page title="Customer list">
              <CustomerList />
            </Page>
          }
        />
        <Route
          path="shop"
          element={
            <Page wide>
              <Shop />
            </Page>
          }
        />
        <Route
          path="income/earning"
          element={
            <Page title="Earning">
              <Earning />
            </Page>
          }
        />
        <Route
          path="income/refunds"
          element={
            <Page title="Refunds">
              <Refunds />
            </Page>
          }
        />
        <Route
          path="income/payouts"
          element={
            <Page title="Payouts">
              <Payouts />
            </Page>
          }
        />
        <Route
          path="income/statements"
          element={
            <Page title="Statements">
              <Statements />
            </Page>
          }
        />
        <Route
          path="promote"
          element={
            <Page title="Promote">
              <Promote />
            </Page>
          }
        />
        <Route
          path="notification"
          element={
            <Page title="Notification">
              <Notification />
            </Page>
          }
        />

        <Route
          path="upgrade-to-pro"
          element={
            <Page title="Upgrade to Pro">
              <UpgradeToPro />
            </Page>
          }
        />
        <Route
          path="message-center"
          element={
            <Page title="Message center">
              <MessageCenter />
            </Page>
          }
        />
        <Route
          path="explore-creators"
          element={
            <Page title="Explore creators">
              <ExploreCreators />
            </Page>
          }
        />
        <Route
          path="affiliate-center"
          element={
            <Page title="Affiliate center">
              <AffiliateCenter />
            </Page>
          }
        /> */}
        </Route>
      </Route>

      <Route element={<PublicRoute />}>
        <Route path="sign-up" element={<SignUp />} />
        <Route path="sign-up" element={<SignUp />} />
        <Route path="sign-in" element={<SignIn />} />
        <Route path="welcome" element={<Welcome />} />

        {/* <Route path="pagelist" element={<PageList />} /> */}
      </Route>
    </Routes>
  );
}

export default App;
